var map = {
	"./action_img.png": 399,
	"./background.png": 613,
	"./banner_shap.png": 614,
	"./cloud-computing.png": 615,
	"./cloud_01.png": 400,
	"./cloud_02.png": 401,
	"./cloud_03.png": 402,
	"./cloud_04.png": 403,
	"./cloud_05.png": 404,
	"./cloud_06.png": 405,
	"./crm_img1.jpg": 616,
	"./crm_img2.jpg": 617,
	"./crm_img3.jpg": 618,
	"./erp_dashboard.jpg": 406,
	"./erp_icon1.png": 619,
	"./erp_icon2.png": 620,
	"./erp_icon3.png": 621,
	"./erp_icon4.png": 622,
	"./erp_icon5.png": 623,
	"./erp_icon6.png": 624,
	"./growth.png": 625,
	"./img/01.png": 407,
	"./img/02.png": 408,
	"./img/03.png": 409,
	"./img/04.png": 410,
	"./img/05.png": 411,
	"./img/06.png": 412,
	"./img/07.png": 413,
	"./img/08.png": 414,
	"./img/09.png": 415,
	"./img/10.png": 416,
	"./img/11.png": 417,
	"./img/12.png": 418,
	"./img/13.png": 419,
	"./img/14.png": 420,
	"./img/15.png": 421,
	"./img/16.png": 422,
	"./img/17.png": 423,
	"./img/18.png": 424,
	"./img/19.png": 425,
	"./img/20.png": 426,
	"./quote.png": 626,
	"./rocket.png": 427,
	"./settings1.png": 627,
	"./shape.png": 628,
	"./testimonial_img.jpg": 629,
	"./testimonial_img2.jpg": 630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;